import { createElementVNode as _createElementVNode, openBlock as _openBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_toast = _resolveComponent("ac-toast")!

  return (_ctx.currentToast)
    ? (_openBlock(), _createBlock(_component_ac_toast, {
        key: _ctx.currentToast.id,
        class: _normalizeClass(_ctx.currentToast.customClass),
        title: _ctx.currentToast.title,
        text: _ctx.currentToast.text,
        type: _ctx.currentToast.type,
        location: _ctx.currentToast.location,
        "text-position": _ctx.currentToast.textPosition,
        timeout: _ctx.currentToast.timeout ?? 0,
        "can-close": _ctx.currentToast.canClose ?? true,
        icon: !_ctx.currentToast.iconHtml && !_ctx.currentToast.iconVariant ? _ctx.currentToast.icon : undefined,
        onClose: _ctx.onClose
      }, _createSlots({ _: 2 }, [
        (_ctx.currentToast.iconHtml)
          ? {
              name: "icon",
              fn: _withCtx(() => [
                _createElementVNode("div", {
                  class: "toast-container_icon",
                  innerHTML: _ctx.currentToast.iconHtml
                }, null, 8, _hoisted_1)
              ]),
              key: "0"
            }
          : (_ctx.currentToast.iconVariant === 'success')
            ? {
                name: "icon",
                fn: _withCtx(() => [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "toast-container_icon" }, [
                    _createElementVNode("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M22 12C22 17.5228 17.5228 22 12 22H2.9937C2.11018 22 1.66771 20.9229 2.29245 20.2929L4.2495 18.3195C2.84334 16.597 2 14.397 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.7071 10.7071C16.0976 10.3166 16.0976 9.68342 15.7071 9.29289C15.3166 8.90237 14.6834 8.90237 14.2929 9.29289L11 12.5858L9.70711 11.2929C9.31658 10.9024 8.68342 10.9024 8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L10.2929 14.7071C10.4804 14.8946 10.7348 15 11 15C11.2652 15 11.5196 14.8946 11.7071 14.7071L15.7071 10.7071Z",
                        fill: "white"
                      })
                    ])
                  ], -1))
                ]),
                key: "1"
              }
            : (_ctx.currentToast.iconVariant === 'error')
              ? {
                  name: "icon",
                  fn: _withCtx(() => [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "toast-container_icon" }, [
                      _createElementVNode("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M12.0007 10.5867L16.2437 6.34372C16.6342 5.95325 17.2673 5.95325 17.6577 6.34372V6.34372C18.0482 6.73418 18.0482 7.36725 17.6577 7.75772L13.4147 12.0007L17.6577 16.2437C18.0482 16.6342 18.0482 17.2673 17.6577 17.6577V17.6577C17.2673 18.0482 16.6342 18.0482 16.2437 17.6577L12.0007 13.4147L7.75772 17.6577C7.36725 18.0482 6.73418 18.0482 6.34372 17.6577V17.6577C5.95325 17.2673 5.95325 16.6342 6.34372 16.2437L10.5867 12.0007L6.34372 7.75772C5.95325 7.36725 5.95325 6.73418 6.34372 6.34372V6.34372C6.73418 5.95325 7.36725 5.95325 7.75772 6.34372L12.0007 10.5867Z",
                          fill: "currentColor"
                        })
                      ])
                    ], -1))
                  ]),
                  key: "2"
                }
              : undefined
      ]), 1032, ["class", "title", "text", "type", "location", "text-position", "timeout", "can-close", "icon", "onClose"]))
    : _createCommentVNode("", true)
}